/**
 * Open links to (larger) images in modal overlay/lightbox
 */

import $ from 'jquery';

export const lightbox = () => {
    const $linkedImage = $('a[href$=".gif"], a[href$=".jpg"], a[href$=".png"]');

    if ($linkedImage.length) {
        $linkedImage.magnificPopup({
            type: 'image',
            gallery: {
                enabled: true,
            },
        });
    }
};
